/**
 * Precios y suscripciones (la consola comercial, ADR-0018 §4a), en español.
 * Las mismas claves que billing.fr.ts, la lengua de referencia.
 */
export const billingEs = {
  "billing.tabs.aria": "Precios y suscripciones",
  "billing.tab.prices": "Precios",
  "billing.tab.promos": "Promociones",
  "billing.tab.discounts": "Descuentos",
  "billing.refreshFailed": "La lista no se ha podido actualizar: se muestra tal como estaba.",
  "billing.anyPlan": "Todos los planes",
  "billing.planWithInterval": "{name}, facturado {interval}",
  "billing.interval.month": "al mes",
  "billing.interval.year": "al año",
  "billing.window": "del {from} al {to}",
  "billing.window.endedEarly": "detenida el {date}",
  "billing.periods.whileSubscribed": "mientras siga suscrito",
  "billing.periods.count": "{count} periodos pagados",
  "billing.state.scheduled": "Programada",
  "billing.state.running": "En curso",
  "billing.state.finished": "Finalizada",
  "billing.state.ended_early": "Detenida antes de tiempo",
  "billing.scope.pro": "Un profesional",
  "billing.scope.country": "Un país",
  "billing.scope.category": "Un oficio",
  "billing.priceState.in_force": "En vigor",
  "billing.priceState.scheduled": "Programado",
  "billing.priceState.superseded": "Sustituido",
  "billing.prices.intro":
    "Un precio nuevo solo se aplica a las suscripciones nuevas. El profesional conserva el precio con el que se suscribió.",
  "billing.prices.loading": "Cargando los precios…",
  "billing.prices.loadFailed": "No se han podido cargar los precios.",
  "billing.prices.empty": "Todavía no hay ningún precio.",
  "billing.prices.unpriced": "Sin precio: {plans}. Nadie puede suscribirse.",
  "billing.prices.imported": "Del importe original del nivel",
  "billing.promos.intro":
    "Una promoción baja el precio de un plan en un país, para quien se suscriba dentro de su ventana. El profesional obtiene solo el precio más bajo: promoción y descuento no se suman.",
  "billing.promos.loading": "Cargando las promociones…",
  "billing.promos.loadFailed": "No se han podido cargar las promociones.",
  "billing.promos.empty": "Ninguna promoción por ahora.",
  "billing.discounts.intro":
    "Un descuento es un porcentaje para un profesional, un país o un oficio. El profesional obtiene solo el precio más bajo: descuento y promoción no se suman.",
  "billing.discounts.loading": "Cargando los descuentos…",
  "billing.discounts.loadFailed": "No se han podido cargar los descuentos.",
  "billing.discounts.empty": "Ningún descuento por ahora.",
  "billing.col.name": "Nombre",
  "billing.col.plan": "Plan",
  "billing.col.country": "País",
  "billing.col.currency": "Moneda",
  "billing.col.amount": "Importe",
  "billing.col.amountDue": "Pendiente de pago",
  "billing.col.promoPrice": "Precio de promoción",
  "billing.col.percentOff": "Descuento",
  "billing.col.periods": "Duración",
  "billing.col.window": "Ventana",
  "billing.col.state": "Estado",
  "billing.col.status": "Estado del pago",
  "billing.col.subscribers": "Profesionales incluidos",
  "billing.col.createdBy": "Creada por",
  "billing.col.setBy": "Establecido por",
  "billing.col.reason": "Razón",
  "billing.col.validFrom": "A partir del",
  "billing.col.who": "Para quién",
  "billing.col.actions": "Acciones",
  "billing.col.date": "Fecha",
  "billing.col.period": "Periodo cubierto",
  "billing.col.provider": "Proveedor",
  "billing.col.eventKind": "Evento",
  "billing.col.via": "Recibido por",
  "billing.col.result": "Resultado",
  "billing.col.detail": "Detalle",
  "billing.col.eventRef": "Referencia del evento",
  "billing.action.setPrice": "Definir un precio",
  "billing.action.newPromo": "Nueva promoción",
  "billing.action.newDiscount": "Nuevo descuento",
  "billing.action.endNow": "Terminar ahora",
  "billing.action.endPromo": "Terminar la promoción",
  "billing.action.endDiscount": "Terminar el descuento",
  "billing.action.extendSubscription": "Alargar",
  "billing.action.endSubscription": "Terminar la suscripción",
  "billing.dialog.setPrice.title": "Definir un precio",
  "billing.dialog.setPrice.body":
    "Este precio se aplicará a las suscripciones nuevas en ese país. Quien ya está suscrito conserva el suyo.",
  "billing.dialog.newPromo.title": "Nueva promoción",
  "billing.dialog.newPromo.body":
    "El precio de promoción sustituye al del país durante la ventana. El profesional lo conserva mientras siga suscrito, hasta el límite indicado.",
  "billing.dialog.newDiscount.title": "Nuevo descuento",
  "billing.dialog.newDiscount.body":
    "Elija un solo destinatario: un profesional, un país o un oficio. El profesional obtiene solo el precio más bajo: descuento y promoción no se suman.",
  "billing.dialog.endPromo.title": "Terminar la promoción {subject}",
  "billing.dialog.endPromo.body": "Nadie más podrá cogerla. Quien ya la tiene, la conserva.",
  "billing.dialog.endDiscount.title": "Terminar el descuento {subject}",
  "billing.dialog.endDiscount.body": "Dejará de aplicarse a las suscripciones nuevas. Quien ya lo tiene, lo conserva.",
  "billing.dialog.extendSubscription.title": "Alargar {subject}",
  "billing.dialog.extendSubscription.body":
    "Gesto comercial: el acceso llega hasta la fecha elegida y se levanta una suspensión. El precio del profesional no cambia.",
  "billing.dialog.endSubscription.title": "Terminar la suscripción {subject}",
  "billing.dialog.endSubscription.body":
    "El acceso se detiene al momento y se ordena al proveedor dejar de cobrar. No hay reembolso: conceda un crédito desde Paiements si procede.",
  "billing.field.plan": "Plan",
  "billing.field.pickPlan": "Elegir un plan",
  "billing.field.country": "País",
  "billing.field.countryHint": "Código de dos letras, por ejemplo GN.",
  "billing.field.currency": "Moneda",
  "billing.field.currencyHint": "Código de tres letras, por ejemplo GNF.",
  "billing.field.amount": "Precio ({currency})",
  "billing.field.validFrom": "A partir del (opcional)",
  "billing.field.validFromHint": "En blanco: el precio se aplica al momento. Nunca una fecha pasada.",
  "billing.field.name": "Nombre",
  "billing.field.nameHint": "Lo que el equipo verá en la lista, por ejemplo «Lanzamiento Conakry».",
  "billing.field.startsAt": "Inicio",
  "billing.field.endsAt": "Final",
  "billing.field.periods": "Número de periodos (opcional)",
  "billing.field.periodsHint": "En blanco: el profesional conserva el precio mientras siga suscrito.",
  "billing.field.scope": "Para quién",
  "billing.field.pro": "El profesional",
  "billing.field.category": "Oficio",
  "billing.field.pickCategory": "Elegir un oficio",
  "billing.field.percentOff": "Porcentaje de descuento",
  "billing.field.paidThrough": "Alargar hasta",
  "billing.field.paidThroughHint": "Una fecha futura. El acceso llega hasta entonces.",
  "billing.problem.reason": "Indique un motivo de al menos {min} caracteres.",
  "billing.problem.plan": "Elija un plan.",
  "billing.problem.country": "Escriba un código de país de dos letras.",
  "billing.problem.currency": "Escriba un código de moneda de tres letras.",
  "billing.problem.amount": "Escriba un importe mayor que cero.",
  "billing.problem.validFrom": "Indique una fecha de inicio válida.",
  "billing.problem.backdated": "Un precio no puede empezar en el pasado.",
  "billing.problem.name": "Indique un nombre de al menos {min} caracteres.",
  "billing.problem.window": "Indique un inicio y un final.",
  "billing.problem.windowOrder": "El final debe ir después del inicio.",
  "billing.problem.periods": "El número de periodos debe ser un entero mayor que cero.",
  "billing.problem.pro": "Elija el profesional al que se aplica.",
  "billing.problem.category": "Elija un oficio.",
  "billing.problem.percentOff": "El porcentaje debe ser un entero entre 1 y 100.",
  "billing.problem.paidThrough": "Indique una fecha de fin válida.",
  "billing.problem.paidThroughPast": "La fecha debe ser futura.",
  "billing.outcome.price": "Precio registrado: {amount}, a partir del {date}.",
  "billing.outcome.promoCreated": "Promoción «{name}» creada.",
  "billing.outcome.promoEnded": "Promoción «{name}» detenida. Quien ya la tiene, la conserva.",
  "billing.outcome.discountCreated": "Descuento «{name}» creado.",
  "billing.outcome.discountEnded": "Descuento «{name}» detenido. Quien ya lo tiene, lo conserva.",
  "billing.outcome.extended": "Suscripción alargada hasta el {date}.",
  "billing.outcome.subscriptionEnded": "Suscripción terminada. El acceso queda cortado y el proveedor ya no cobrará.",
  "billing.error.stale": "Esto ha cambiado mientras lo miraba. Recárguelo, compruébelo y vuelva a intentarlo.",
  "billing.error.refused": "Rechazado: sus roles no incluyen la función necesaria. Pida acceso a un responsable.",
  "billing.error.invalid": "Rechazado: lo enviado ya no encaja. Recargue y compruebe.",
  "billing.error.outcomeUnknown":
    "Sin respuesta del servidor: puede haber quedado registrado. Vuelva a intentarlo: el mismo clic no se aplica dos veces.",
  "billing.refused.planNotPriced": "Rechazado: ese plan aún no tiene precio en ese país. Defínalo primero.",
  "billing.refused.invalidAmount": "Rechazado: el importe debe ser mayor que cero.",
  "billing.refused.backdated": "Rechazado: un precio no puede empezar en el pasado.",
  "billing.refused.priceVersionExists":
    "Rechazado: ya empieza una versión en ese momento para ese plan y país. Recargue la lista.",
  "billing.refused.invalidWindow": "Rechazado: la ventana no es válida. El final debe ir después del inicio.",
  "billing.refused.alreadyOver": "Rechazado: esto ya ha terminado. Recargue la lista.",
  "billing.refused.idempotencyKeyRequired":
    "Rechazado: la petición salió sin su clave. Cierre la ventana y empiece de nuevo.",
  "billing.subscription.pending": "Pendiente",
  "billing.subscription.active": "Activo",
  "billing.subscription.ending": "Sin renovación",
  "billing.subscription.suspended": "Suspendido",
  "billing.subscription.ended": "Finalizado",
  "billing.endReason.renewal_cancelled": "Renovación cancelada por el profesional",
  "billing.endReason.unpaid": "Renovación sin pagar",
  "billing.endReason.checkout_abandoned": "Pago nunca completado",
  "billing.endReason.replaced": "Sustituido por otra suscripción",
  "billing.endReason.ended_by_staff": "Terminado por el equipo",
  "billing.endReason.ended_by_provider": "Terminado por el proveedor",
  "billing.event.payment_succeeded": "Pago correcto",
  "billing.event.payment_failed": "Pago fallido",
  "billing.event.subscription_ended": "Suscripción terminada",
  "billing.via.webhook": "Webhook del proveedor",
  "billing.via.poll": "Consultado por Walliyo",
  "billing.via.return": "Vuelta a la aplicación",
  "billing.via.reconcile": "Conciliación",
  "billing.result.applied": "Aplicado",
  "billing.result.conflict": "Conflicto",
  "billing.result.ignored": "Ignorado",
  "billing.priceInsteadOf": "{now} en lugar de {regular}",
  "billing.reductionWithPeriods": "{name} · quedan {count} periodos",
  "billing.sub.loading": "Cargando la suscripción…",
  "billing.sub.loadFailed": "No se ha podido cargar la suscripción.",
  "billing.sub.none": "Este profesional nunca se ha suscrito.",
  "billing.sub.credit": "Crédito",
  "billing.sub.noCredit": "Ninguno",
  "billing.sub.noRefunds":
    "No hay reembolso en una suscripción. Un gesto es un crédito, concedido desde Paiements, descontado del pago siguiente.",
  "billing.sub.creditLink": "Sus pagos, para conceder un crédito →",
  "billing.sub.discountLink": "Ofrecer un descuento a este profesional →",
  "billing.sub.since": "Abierta el {date}",
  "billing.sub.versionTitle": "La versión de la suscripción mostrada: cada escritura la envía.",
  "billing.sub.entitled": "Acceso abierto",
  "billing.sub.notEntitled": "Sin acceso",
  "billing.sub.provider": "Proveedor",
  "billing.sub.renewsAutomatically": "se renueva automáticamente",
  "billing.sub.paidByHand": "pagado a mano por el profesional",
  "billing.sub.country": "País",
  "billing.sub.price": "Precio actual",
  "billing.sub.reduction": "Reducción",
  "billing.sub.nextPlan": "Cambio de plan",
  "billing.sub.nextPlanValue": "cambia a {plan} al final del periodo",
  "billing.sub.paidThrough": "Pagado hasta",
  "billing.sub.renewalCancelled": "Renovación cancelada el",
  "billing.sub.graceEnds": "Periodo de gracia hasta",
  "billing.sub.ended": "Finalizada el",
  "billing.sub.endReason": "Motivo del final",
  "billing.sub.payments": "Pagos",
  "billing.sub.noPayments": "Ningún pago en esta suscripción.",
  "billing.sub.noPeriod": "Todavía sin cubrir",
  "billing.sub.events": "Eventos del proveedor",
  "billing.sub.noEvents": "Ningún evento del proveedor.",
  "billing.sub.actions": "Actuar sobre esta suscripción",
  "billing.sub.actionsFoot":
    "Alargar es un gesto, terminar es una sanción. Ambos piden un motivo y quedan en el registro de auditoría.",
} as const;
